import React from "react";
import { Skeleton, TableCell, TableRow } from "@mui/material";

interface LoadingTableProps {
  rowsCount?: number; // number of skeleton rows
  columns?: number;   // number of columns to show skeletons
}

const LoadingTable: React.FC<LoadingTableProps> = ({ rowsCount = 5, columns = 2 }) => {
  return (
    <>
      {Array.from({ length: rowsCount }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <TableCell key={colIndex}>
              <Skeleton variant="text" width="100%" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default LoadingTable;
